import { FilterComponent } from './tag/filters';
import InfinityScroll from '../components/infinityScroll';
import setTopBar from '../components/topBar.js';
import setCategoriesSlider from './tag/categories_slider.js';

const Tag = {
  init: function () {
    setTopBar();
    setCategoriesSlider();
    FilterComponent.init();
    InfinityScroll.init();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Tag.init();
});
